<form [formGroup]="formGroup" class="flex gap-2 flex-wrap sm:flex-nowrap">
  @if (languagesService.isTranslationsLoaded && filterDefinition) {
    @if (filterDefinition.options?.length) {
      <div class="w-[200px] sm:w-[150px]">
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select
            formControlName="values"
            multiple="true"
            [panelWidth]="null"
            [placeholder]="'COMMON.PLACEHOLDER.SELECT' | transloco"
            >
            <aup-select-check-all
              [text]="'COMMON.SELECT_ALL' | transloco"
              [textWhenSelectedAll]="'COMMON.UNSELECT_ALL' | transloco"
              [values]="filterDefinition.options!"
              [model]="formControl"
            ></aup-select-check-all>
            @for (option of filterDefinition.options; track option) {
              <mat-option [value]="option.value">
                {{ option.label | transloco }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    } @else {
      @if (filterDefinition.optionsGroups?.length) {
        <mat-form-field
          class="w-[150px] min-w-[150px]"
          appearance="outline"
          [subscriptSizing]="'dynamic'"
          >
          <mat-select
            formControlName="values"
            multiple="true"
            [panelWidth]="null"
            [placeholder]="'COMMON.PLACEHOLDER.SELECT' | transloco"
            >
            <aup-select-check-all
              [text]="'COMMON.SELECT_ALL' | transloco"
              [textWhenSelectedAll]="'COMMON.UNSELECT_ALL' | transloco"
              [values]="getAllOptions(filterDefinition.optionsGroups!)"
              [model]="formControl"
            ></aup-select-check-all>
            @for (group of filterDefinition.optionsGroups; track group) {
              <mat-optgroup [label]="group.label | transloco">
                @for (option of group.options; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label | transloco }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      }
    }
  }

</form>
